export default "https://cdn-static.gokick.com/assets/94c0a6f1f1290e979b6f5177b757303844c3d722/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";